<template>
  <div class="max-w-2xl w-full min-h-50">
    <CaptchaPop
      v-if="isShowCaptchaVerify"
      v-on:closeEmailPop="closeEmailPop"
      v-on:isCodeVerify="isCodeVerify"
      :verifyStatus="verifyStatus"
      />

    <div class="pb-5" v-if="authorized && user">
      <ul class="border-b py-4 mb-4 text-NotoSansRegular px-2 md:px-12 font-light">
        <li class="py-2 md:py-3 flex flex-wrap" v-if="user.email">
          <span>會員帳號：{{ user.email }}</span>
          <button class="btn mt-1 md:mt-0 ml-2 cursor-pointer text-NotoSansRegular button-red text-white py-1 px-4 rounded text-sm"
            v-if="!user.email_verified_at && !isCheckingAccount" @click="verifyEmail">
            <span>驗證</span>
          </button>
          <a class="btn mt-1 md:mt-0 ml-2 cursor-default text-NotoSansRegular bg-red-800 text-white py-1 px-2 rounded text-sm"
            v-if="!user.email_verified_at && isCheckingAccount">
            <span>驗證</span>
            <font-awesome-icon icon="circle-notch" spin class="text-center ml-1" />
          </a>
        </li>
        <li class="py-2 md:py-3">
          <span>會員姓名：{{ user.name ? user.name : '' }}</span>
        </li>
        <li class="py-2 md:py-3">
          <span>會員生日：{{ user.birth ? moment(user.birth).format('YYYY/MM/DD') : '' }}</span>
        </li>
        <li class="py-2 md:py-3">
          <span>手機號碼：({{ user.country_code ? user.country_code : '+886' }}) {{ user.mobile }}</span>
        </li>
        <li class="py-2 md:py-3">
          <span>聯絡地址：{{ user.zip_code }} {{ user.city }}{{ user.district }}{{ user.address }}</span>
        </li>
        <li class="py-2 md:py-3">
          <span>受贈機關或團體：<span  v-if="isLoad">{{ donationText ? donationText : '' }}</span></span>
        </li>
      </ul>

      <div class="w-full flex justify-center lg:justify-end px-1 md:px-2 mb-8">
        <router-link
          class="cursor-pointer text-NotoSansRegular button-red text-white py-2 px-12 rounded"
          :to="{ name: 'account' }">
          修改個人資料及密碼
        </router-link>
      </div>
    </div>
    <img src="~@/assets/icon/Pulse.gif" class="mx-auto h-12" v-else>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import CaptchaPop from '@/components/checkout/CaptchaPop'
export default {
  name: 'Manage',
  data () {
    return {
      donationText: '',
      isShowCaptchaVerify: false,
      isCheckingAccount: false,

      verifyStatus: '',

      isLoad: false
    }
  },

  components: {
    CaptchaPop
  },
  computed: {
    ...mapGetters([
      'authorized',
      'userRole',
      'user'
    ]),
    mobileVal () {
      if (this.user && this.user && this.user.mobile) {
        return this.user.mobile
      } else if (this.user && this.user.mobile) {
        return this.user.mobile
      } else {
        return ''
      }
    }
  },
  created () {
  },
  mounted () {
    this.checkAuthorized()
    this.getlovecode()
  },
  methods: {
    getlovecode () {
      if (this.user && this.user.invoice_donation && typeof this.user.invoice_donation === 'string' && this.user.invoice_donation.length > 0) {
        axios.get('/cart/lovecode/list')
          .then((response) => {
            let counters = [...response.data]
            let index = counters.findIndex(x => x.code === this.user.invoice_donation)
            this.donationText = this.user.invoice_donation + ' ' + response.data[index].name
            this.isLoad = true
          })
      } else {
        this.isLoad = true
      }
    },
    checkAuthorized () {
      if (!this.authorized) {
        this.$router.push({ name: 'login' })
      } else {
        this.$store.dispatch('getProfile')
      }
    },
    async verifyEmail () {
      this.isCheckingAccount = true
      await axios.get('/user/verify/mail')
        .then((response) => {
          this.verifyStatus = response.data
          this.isShowCaptchaVerify = true
          this.isCheckingAccount = false
        })
        .catch((error) => {
          console.log(error)
          this.isCheckingAccount = false
        })
    },
    // 關掉驗證視窗
    closeEmailPop (closeEmailPop) {
      this.isShowCaptchaVerify = closeEmailPop
    },
    // 獲取驗證碼
    isCodeVerify (isCodeVerify) {
      if (isCodeVerify) {
        this.$store.dispatch('getProfile')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading {
    cursor: none;
  }
  .vcurrency {
    li {
      span {
        display: inline-block;
        width: 134px;
      }
    }
  }
  .table-order {
    tbody {
      tr {
        td {
          padding: .5rem 0;
        }
      }
    }
  }
  .table-order td>span {
      display: none;
  }

  @media (max-width: 640px) {
    .table-order thead tr:first-child {
        display: none;
      }
    .table-order tbody, .table-order td, .table-order tbody tr {
        display: block;
        text-align: left;
    }
    .table-order tbody tr {
        border-bottom: 1px solid #e9e9e9;
        padding: 12px 0;
        font-size: 0;
    }
    .table-order tbody, .table-order td, .table-order tr {
        display: block;
        text-align: left;
    }
    .table-order td {
        width: 50%;
        display: inline-block;
        box-sizing: border-box;
        padding: 6px 6px 6px 0;
        vertical-align: top;
        font-size: 13px;
    }
    .table-order tbody, .table-order td, .table-order tr {
        display: block;
        text-align: left;
    }
    .table-order td>span {
        display: inline-block;
    }
  }
</style>
